import { ActionTypes } from "../constants/ActionTypes";
import { API_ENDPOINTS } from "../../utils/api-endpoints";
import { ReactProjectBaseUrl } from "../../utils/Constants";
import { getApiToken, getBranchToken, isGeofenchingEnabled } from "../../utils/get-token";
import axios from "axios";

export const getproduct =
  (page, orderByProducts, itemLimit) => async (dispatch, getState) => {
    const product = getState().products;
    const brandFilter = getState().brandFilter;
    const categoryFilter = getState().categoryFilter;
    const maxprice = getState().pricerange.maxprice;
    const minprice = getState().pricerange.minprice;
    const inclueOutOfStock = getState().inclueOutOfStock;
    let categoryFilerIds = [];

    let response = [];

    let newCategoriesArray = [...product];

    if (brandFilter.length > 0 && categoryFilter.length > 0) {
      if (page == 0) {
        newCategoriesArray = [];
      }
      categoryFilerIds = [];
      for (let index = 0; index < categoryFilter.length; index++) {
        categoryFilerIds.push(categoryFilter[index].id);
      }
    } else {
      if (brandFilter.length > 0) {
        if (page == 0) {
          newCategoriesArray = [];
        }
      }

      if (categoryFilter.length > 0) {
        categoryFilerIds = [];
        for (let index = 0; index < categoryFilter.length; index++) {
          categoryFilerIds.push(categoryFilter[index].id);
        }
        if (page == 0) {
          newCategoriesArray = [];
        }
      }
      if (!(brandFilter.length > 0 && categoryFilter.length > 0)) {
        if (page == 0) {
          newCategoriesArray = [];
        }
      }
    }

    const token = isGeofenchingEnabled() == 1 ? getBranchToken() : getApiToken()

    await axios
      .get(
        ReactProjectBaseUrl +
          API_ENDPOINTS.FETCH_PRODUCT_LIST +
          "?page=" +
          page +
          "&length=" +
          itemLimit +
          "&brands=" +
          brandFilter.toString() +
          "&categorys=" +
          categoryFilerIds.toString() +
          "&order=" +
          orderByProducts +
          "&minprice=" +
          minprice +
          "&maxprice=" +
          maxprice +
          "&inclueoutofstock=" +
          inclueOutOfStock,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            API_TOKEN: token,
          },
        }
      )
      .then((data) => {
        response = data.data;
      });
    const productResponse = response.response;
    let productList = [];
    let allProductCount = 0;

    if (productResponse) {
      productList = productResponse.ecommerceResponse;
      allProductCount = productResponse.count;
    }

    const appendedProductList = newCategoriesArray.concat(productList);

    //const appendedProductListFiltered = ((inclueOutOfStock === 0) ? (appendedProductList.filter((x) => x.quantity > 0)) : (appendedProductList))

    dispatch({ type: ActionTypes.SET_TOTAL_PRODUCT, payload: allProductCount });
    dispatch({ type: ActionTypes.SET_PRODUCTS, payload: appendedProductList });
  };

export const resetProducts = () => (dispatch) => {
  dispatch({ type: ActionTypes.RESET_PRODUCTS, payload: [] });
};

export const resetTotalProducts = () => async (dispatch, getState) => {
  dispatch({ type: ActionTypes.RESET_TOTAL_PRODUCTS, payload: 0 });
};

export const clearProductState = () => async (dispatch, getState) => {
  dispatch({ type: ActionTypes.SET_PRODUCTS, payload: [] });
};
